export default __webpack_public_path__ + "static/media/26.94aba0cd.jpg";